import axios from '../utils/axios';

export const orderService = {
    // Получение всех заказов с фильтрами
    getAllOrders: async (params) => {
        const response = await axios.get('/orders', { params });
        return response.data;
    },

    // Получение заказов пользователя
    getUserOrders: async () => {
        const response = await axios.get('/orders/my');
        return response.data;
    },

    // Получение конкретного заказа
    getOrderById: async (orderId) => {
        const response = await axios.get(`/orders/${orderId}`);
        return response.data;
    },

    // Получение статистики
    getOrderStats: async (params) => {
        const response = await axios.get('/orders/stats', { params });
        return response.data;
    },

    // Пометить заказ как "ненаход" с опциональным пополнением баланса
    markNotFound: async (orderId, { topUpAmount = 0, comment = '' } = {}) => {
        const response = await axios.post(`/orders/${orderId}/not-found`, { topUpAmount, comment });
        return response.data;
    }
};
